import React from 'react';

const ArticleListPagination = ({ itemsPerPage, totalItems, paginate, currentPage, isCommissioned }) => {
    const pageNumbers = [];
    const totalPageCount = Math.ceil(totalItems / itemsPerPage);
    const pageNumberLimit = isCommissioned ? 4 : 2;
    const maxPageNumberLimit = currentPage + pageNumberLimit;
    const minPageNumberLimit = currentPage - pageNumberLimit;

    for (let i = 1; i <= totalPageCount; i++) {
        pageNumbers.push(i);
        if (isCommissioned && i === totalPageCount) {
            pageNumbers.push(i + 1)
        }
    }

    return (
        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
                <li className='page-item'>
                    <a
                        href='javascript:void(0);'
                        className='page-link'
                        onClick={() => paginate(isCommissioned == true ? 0 : 1)}
                        disabled={currentPage === 1}
                    >
                        <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                    </a>
                </li>
                <li className='page-item'>
                    <a
                        href='javascript:void(0);'
                        className='page-link'
                        onClick={() => currentPage > 1 ? paginate(currentPage - 1) : (currentPage == 1 && isCommissioned) ? paginate(0) : null}
                        disabled={currentPage === 1}
                    >
                        <i className="fa fa-angle-left" aria-hidden="true"></i>
                    </a>
                </li>
                {/* {pageNumbers.filter(number => (number < maxPageNumberLimit + 1 && number > minPageNumberLimit - 1)).map(number => (
                    <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                        <a onClick={() => paginate(number)} href='javascript:void(0);' className='page-link'>
                            {number}
                        </a>
                    </li>
                ))} */}
                {pageNumbers.filter(number => (number < maxPageNumberLimit + 1 && number > minPageNumberLimit - 1)).map(number => (
                    <li key={number} className={`page-item ${isCommissioned ? (number - 1 === currentPage ? 'active' : '') : (number === currentPage ? 'active' : '')}`}>
                        <a onClick={() => paginate(isCommissioned ? number - 1 : number)} href='javascript:void(0);' className='page-link'>
                            {number}
                        </a>
                    </li>
                ))}
                {maxPageNumberLimit < totalPageCount && (
                    <>
                        <li className='page-item'>
                            <span className='page-link'>...</span>
                        </li>
                        <li className='page-item'>
                            <a onClick={() => paginate(totalPageCount)} href='javascript:void(0);' className='page-link'>
                                {totalPageCount}
                            </a>
                        </li>
                    </>
                )}
                <li className='page-item'>
                    <a
                        href='javascript:void(0);'
                        className='page-link'
                        onClick={() => currentPage < totalPageCount ? paginate(currentPage + 1) : null}
                        disabled={currentPage === totalPageCount}
                    >
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </a>
                </li>
                <li className='page-item'>
                    <a
                        href='javascript:void(0);'
                        className='page-link'
                        onClick={() => paginate(totalPageCount)}
                        disabled={currentPage === totalPageCount}
                    >
                        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default ArticleListPagination;